/**
 * Version History API service
 * Handles cloud (Supabase) version operations via Netlify functions
 */
import { getAuthHeader } from "./authService";
import { API_BASE_URL } from "../config/api";
import { httpGet, httpPost, httpDelete } from "../utils/http";

const VERSIONS_API = `${API_BASE_URL}/song-versions`;

const handleResponse = async (response) => {
  if (!response.ok) {
    const error = await response
      .json()
      .catch(() => ({ error: "Request failed" }));
    throw new Error(
      error.message ||
        error.error ||
        `Request failed with status ${response.status}`,
    );
  }
  return response.json();
};

/**
 * List all versions for a song (metadata only, no content)
 */
export const listVersions = async (songId) => {
  const authHeaders = await getAuthHeader();
  const response = await httpGet(`${VERSIONS_API}?songId=${songId}`, {
    "Content-Type": "application/json",
    ...authHeaders,
  });
  const data = await handleResponse(response);
  return data.versions || [];
};

/**
 * Get a specific version's full content
 */
export const getVersionContent = async (songId, versionNumber) => {
  const authHeaders = await getAuthHeader();
  const response = await httpGet(
    `${VERSIONS_API}?songId=${songId}&version=${versionNumber}`,
    { "Content-Type": "application/json", ...authHeaders },
  );
  const data = await handleResponse(response);
  return data.version || null;
};

/**
 * Create a new version
 */
export const createVersion = async (songId, title, content, changeSummary) => {
  const authHeaders = await getAuthHeader();
  const response = await httpPost(
    VERSIONS_API,
    { songId, title, content, changeSummary },
    { "Content-Type": "application/json", ...authHeaders },
  );
  const data = await handleResponse(response);
  return data.version;
};

/**
 * Delete a specific version
 */
export const deleteVersionFromServer = async (songId, versionNumber) => {
  const authHeaders = await getAuthHeader();
  const response = await httpDelete(
    `${VERSIONS_API}?songId=${songId}&version=${versionNumber}`,
    { "Content-Type": "application/json", ...authHeaders },
  );
  return handleResponse(response);
};

export default {
  listVersions,
  getVersionContent,
  createVersion,
  deleteVersionFromServer,
};
